<div class="container">
	<div class="container-body  main-center">

		<!-- Filtro -->
		<form class="row filters form-inline">
			<!-- FILTRO Fechas -->
			<div class="col-sm-7">
				<div class="form-group">
					<span class="labelWidth"
						for="daterangeInput">{{ modelService.getString('project_list_filter_date') }}</span>
					<div class="input-group">
						<span class="input-group-text"><i class="fa fa-calendar" aria-hidden="true"></i></span>
						<input #dateRangePicker type="text" style="min-width: 212px;" class="form-control" name="daterangeInput" daterangepicker
							[options]="options" (selected)="onSelectDate($event)"
							(applyDaterangepicker)="calendarApplied($event)" />
					</div>
				</div>
			</div>
			<!-- FILTRO Estado -->
			<div class="col-sm-5">
				<div class="form-group" style="justify-content: flex-end;">
					<label for="stateFilterSelect">{{ modelService.getString('project_list_filter_state') }}</label>
					<select class="form-control" id="stateFilterSelect" ([ngModel])="selectStatus"
						(change)="onSelectStatus($event)">
						<option *ngFor="let item of statusList" (ngValue)="item">
							{{ modelService.getString(item.label) }}</option>
					</select>
				</div>
			</div>
			<!-- FILTRO Nombre proyecto -->
			<div class="col-sm-12 m15top">
				<div class="form-group">
					<span class="labelWidth"
						for="selecterProject">{{ modelService.getString('project_list_filter_name') }}</span>
					<div class="input-group" style="width: calc(100% - 160px);">
						<input type="text"
							placeholder="{{ modelService.getString('project_list_filter_name_placeholder') }}"
							class="form-control" [(ngModel)]="selectProject" name="selecterProject" (keyup)="doFilter(true)" />
					</div>
				</div>
			</div>
			<!-- FILTRO Nombre usuario -->
			<div *ngIf="adminMode || empresaMode" class="col-sm-12 m15top">
				<div class="form-group">
					<span class="labelWidth"
						for="selectUserName">{{ modelService.getString('project_list_filter_user') }}</span>
					<div class="input-group" style="width: calc(100% - 160px);">
						<select class="form-control" id="selectUserName" name="selectUserName"
							[(ngModel)]="selectUserId" (change)="onSelectUserNameEmail($event)">
							<option value="">{{ modelService.getString('project_list_filter_user_placeholder') }}</option>
							<option *ngFor="let item of listNameUser" [ngValue]="item.id">{{ item.title}}</option>
						</select>
					</div>
				</div>
			</div>
			<!-- FILTRO Email usuario -->
			<div *ngIf="adminMode || empresaMode" class="col-sm-12 m15top">
				<div class="form-group">
					<span class="labelWidth"
						for="selectUserEmail">{{ modelService.getString('project_list_filter_email') }}</span>
					<div class="input-group" style="width: calc(100% - 160px);">
						<select class="form-control" id="selectUserEmail" name="selectUserEmail"
							[(ngModel)]="selectUserId" (change)="onSelectUserNameEmail($event)">
							<option value="">{{ modelService.getString('project_list_filter_email_placeholder') }}</option>
							<option *ngFor="let item of listEmailUser" [ngValue]="item.id">{{ item.title }}</option>
						</select>
					</div>
				</div>
			</div>
			<!-- FILTRO Empresa -->
			<div *ngIf="adminMode" class="col-sm-12 m15top">
				<div class="form-group">
					<span class="labelWidth"
						for="selectEmpresa">{{ modelService.getString('project_list_filter_CIA') }}</span>
					<div class="input-group" style="width: calc(100% - 160px);">
						<select class="form-control" id="selectEmpresa" name="selectEmpresa"
							[(ngModel)]="selectCIA" (change)="onSelectCIANameCode($event)">
							<option value="">{{ modelService.getString('project_list_filter_CIA_placeholder') }}</option>
							<option *ngFor="let item of listNameCIA" [ngValue]="item.code">{{ item.title}}</option>
						</select>
					</div>
				</div>
			</div>
			<!-- FILTRO Código -->
			<div *ngIf="adminMode" class="col-sm-12 m15top">
				<div class="form-group">
					<span class="labelWidth"
						for="selectCodigo">{{ modelService.getString('project_list_filter_code') }}</span>
					<div class="input-group" style="width: calc(30% - 160px);">
						<select class="form-control" id="selectCodigo" name="selectCodigo"
							[(ngModel)]="selectCIA" (change)="onSelectCIANameCode($event)">
							<option value="">{{ modelService.getString('project_list_filter_code_placeholder') }}</option>
							<option *ngFor="let item of listCodeCIA" [ngValue]="item.code">{{ item.title}}</option>
						</select>
					</div>
				</div>
			</div>
		</form>

		<!-- Páginador -->
		<div class="row" style="padding-top: 10px;">
			<div class="col">
				<nav aria-label="Page navigation example">
					<ul *ngIf="showPaginete" class="pagination justify-content-end">

						<li class="page-item">
							<a class="page-link" aria-label="Previous" (click)="firstPage()" style="cursor: pointer;">
								<i class="fa fa-angle-double-left" aria-hidden="true"></i>
							</a>
						</li>

						<li class="page-item">
							<a class="page-link" aria-label="Previous" (click)="previousPage()" style="cursor: pointer;">
								<i class="fa fa-angle-left" aria-hidden="true"></i>
							</a>
						</li>

						<li *ngFor="let item of btnsPage" class="page-item">
							<a *ngIf="item.page > -1 && item.page !== currentPage" class="page-link"  (click)="paginate(item.page)" style="cursor: pointer;">
								<span aria-hidden="true">{{item.text}}</span>
							</a>
							<a *ngIf="item.page === currentPage || item.page === -1" class="page-link" style="cursor: default;">
								<span aria-hidden="true" style="color: black;"><strong>{{item.text}}</strong></span>
							</a>
						</li>

						<li class="page-item">
							<a class="page-link" aria-label="Next" (click)="nextPage()" style="cursor: pointer;">
								<i class="fa fa-angle-right" aria-hidden="true"></i>
							</a>
						</li>

						<li class="page-item">
							<a class="page-link" aria-label="Next" (click)="lastPage()" style="cursor: pointer;">
								<i class="fa fa-angle-double-right" aria-hidden="true"></i>
							</a>
						</li>

					</ul>
				</nav>
			</div>
		</div>

		<!-- Listado de proyectos -->
		<div class="row list">
			<!-- esto es un comentario -->
			<ul class="project-list">

				<li *ngIf="!projectList" class="project-info loader">
					<!--i (click)="deleteProject(project)" class="fa fa-circle-o-notch fa-spin fa-4x"></i-->
				</li>

				<li *ngIf="projectList && projectList.length === 0" class="project-info-no-results">
					<span>{{modelService.getString('project_list_filter_nothing')}}</span>
				</li>

				<li *ngFor="let project of projectList; let index = index;" class="project-info"
					[class.alt]="index%2==0">

					<!-- Menú contextual -->
					<div class="btn-group dropend">
						<div class="delete" data-bs-toggle="dropdown" aria-expanded="false">
							<i class="fa fa-reorder fa-2x"></i>
						</div>
						<!--button type="button" class="btn" data-bs-toggle="dropdown" aria-expanded="false">
							<i class="fa fa-reorder fa-2x"></i>
						</button-->
						<ul class="dropdown-menu subMenuListProjects">
							<li (click)="editProject(project)">
								<i class="fa fa-edit"></i>
								<span>{{ modelService.getString( (project.estado > 0 ? 'project_list_view' :'project_list_edit') ) }}</span>
							</li>
							<li (click)="projectListService.downloadProject(project, false)">
								<i class="fa fa-download"></i>
								<span>{{ modelService.getString('project_list_download') }}</span>
							</li>
							<li (click)="projectListService.downloadProject(project, true)">
								<i class="fa fa-download"></i>
								<span>{{ modelService.getString('project_list_download_MC') }}</span>
							</li>
							<li (click)="viewQuote(project)">
								<i class="fa fa-eye"></i>
								<span>{{ modelService.getString('project_list_status') }}</span>
							</li>
							<li [class.borrado]="buttonDeleteProject(project)" (click)="deleteProject(project)">
								<i class="fa fa-trash"></i>
								<span>{{ modelService.getString('project_list_delete') }}</span>
							</li>
						</ul>
					</div>

					<!--div class="delete" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false"><i class="fa fa-reorder fa-2x"></i>				</div>
					<ul class="dropdown-menu subMenuListProjects" aria-labelledby="dropdownMenuButton">
						<li (click)="editProject(project)">
							<i class="fa fa-edit"></i><span>{{ modelService.getString( (project.estado > 0 ? 'project_list_view' :'project_list_edit') ) }}</span>
						</li>
						<li (click)="projectListService.downloadProject(project, false)">
							<i class="fa fa-download"></i><span>{{ modelService.getString('project_list_download') }}</span>
						</li>
						<li (click)="projectListService.downloadProject(project, true)">
							<i class="fa fa-download"></i><span>{{ modelService.getString('project_list_download_MC') }}</span>
						</li>
						<li (click)="viewQuote(project)">
							<i class="fa fa-eye"></i><span>{{ modelService.getString('project_list_status') }}</span>
						</li>
						<li [class.borrado]="buttonDeleteProject(project)" (click)="deleteProject(project)">
							<i class="fa fa-trash"></i><span>Borrar proyecto</span>
						</li>
					</ul-->

					<!-- Miniatura de proyecto Esquema -->
					<svg *ngIf="project.renderer=='canvas2d'" height="120" width="192" class="image"
						(click)="editProject(project)" [attr.viewBox]="project.mini.viewBox">
						<path [attr.d]="project.mini.path" style="fill:none;stroke:black;stroke-width:1" />
					</svg>

					<!-- Miniature de proyecto Satélite -->
					<img *ngIf="project.renderer!='canvas2d'" class="image" (click)="editProject(project)"
						[attr.src]="getProjectImageSatelite(project, 'img' + index)" alt="{{ project.nombre }}"
						[attr.id]="'img'+index">

					<!--  -->
					<div class="details">
						<h4><strong>{{ modelService.getString('project_list_date') }}</strong>&nbsp; {{ project.fechaCreacion.toLocaleDateString() }}</h4>
						<h3 class="haveClick" (click)="editProject(project)"> {{ project.nombre }}</h3>
						<h4><strong>{{ modelService.getString('project_list_CIA') }}</strong>&nbsp;{{getCIA(project.userId)}}</h4>
						<h4><strong>{{ modelService.getString('project_list_user') }}</strong>&nbsp;{{getNamesUser(project.userId)}}</h4>
						<h4><strong>{{ modelService.getString('project_list_state') }}</strong>&nbsp;{{ project.estado | projectStatusPipe }}</h4>
					</div>
					<ul class="options">
						<li>
							<select name="mcSelect" [(ngModel)]="project.mc" (change)="mcChange(project)">
								<option [ngValue]="0">{{ modelService.getString('project_list_default') }}</option>
								<!--option *ngFor="let number of earningsSteps; let index=index;" [ngValue]="number">{{number}}%</option-->
								<option *ngFor="let number of steps; let index=index;" [ngValue]="number">{{number}}%
								</option>
							</select>
							<label for="mcSelect">{{ modelService.getString('project_list_MC') }}&nbsp;&nbsp;</label>
						</li>
						<!-- li (click)="editProject(project)"><i class="fa fa-edit fa-2x"></i>
							<span>{{ modelService.getString( (project.estado > 0 ? 'project_list_view' :'project_list_edit') ) }}</span></li>
						<li (click)="projectListService.downloadProject(project, false)"><i class="fa fa-download fa-2x"></i>
							<span>{{ modelService.getString('project_list_download') }}</span></li>
						<li (click)="projectListService.downloadProject(project, true)"><i class="fa fa-download fa-2x"></i>
							<span>{{ modelService.getString('project_list_download_MC') }}</span></li>
						<li (click)="viewQuote(project)"><i class="fa fa-eye fa-2x"></i>
							<span>{{ modelService.getString('project_list_status') }}</span></li-->
					</ul>
				</li>
			</ul>
		</div>

		<!-- Páginador -->
		<div class="row" style="padding-top: 10px; margin-bottom: 60px;">
			<div class="col">
				<nav aria-label="Page navigation example">
					<ul *ngIf="showPaginete" class="pagination justify-content-end">

						<li class="page-item">
							<a class="page-link" aria-label="Previous" (click)="firstPage()" style="cursor: pointer;">
								<i class="fa fa-angle-double-left" aria-hidden="true"></i>
							</a>
						</li>

						<li class="page-item">
							<a class="page-link" aria-label="Previous" (click)="previousPage()" style="cursor: pointer;">
								<i class="fa fa-angle-left" aria-hidden="true"></i>
							</a>
						</li>

						<li *ngFor="let item of btnsPage" class="page-item">
							<a *ngIf="item.page > -1 && item.page !== currentPage" class="page-link"  (click)="paginate(item.page)" style="cursor: pointer;">
								<span aria-hidden="true">{{item.text}}</span>
							</a>
							<a *ngIf="item.page === currentPage || item.page === -1" class="page-link" style="cursor: default;">
								<span aria-hidden="true" style="color: black;"><strong>{{item.text}}</strong></span>
							</a>
						</li>

						<li class="page-item">
							<a class="page-link" aria-label="Next" (click)="nextPage()" style="cursor: pointer;">
								<i class="fa fa-angle-right" aria-hidden="true"></i>
							</a>
						</li>

						<li class="page-item">
							<a class="page-link" aria-label="Next" (click)="lastPage()" style="cursor: pointer;">
								<i class="fa fa-angle-double-right" aria-hidden="true"></i>
							</a>
						</li>

					</ul>
				</nav>
			</div>
		</div>

	</div>
</div>

<app-alert #alertWindow1 ></app-alert>